const DISPLAY_TARGET_HOSTS = [
  { hostname: 'integration-www.nankaiapp.com', environmentName: 'integration' },
  { hostname: 'staging-www.nankaiapp.com', environmentName: 'staging' },
  { hostname: 'localhost', environmentName: 'local' },
  { hostname: '127.0.0.1', environmentName: 'local' }
]

// 画面に表示する環境名を返す。表示対象外（production）の場合は null。
export const displayedEnvironmentName = () => {
  const { hostname } = window.location
  const target = DISPLAY_TARGET_HOSTS.find(t => (
    hostname === t.hostname || hostname.indexOf(`${t.hostname}.`) === 0
  ))

  return target ? target.environmentName : null
}
